/**
 * The Org (Handbook) nav entry's adoption event, sent over HTTP (Issue
 * #13434). Moved from the deleted header module when the top navigation
 * went (#16727); the account menu's Handbook row is its caller.
 *
 * WHY THIS IS NOT A SERVER ACTION. The call site is a `<Link>`'s `onClick`,
 * so this fires at the same instant the link's navigation is serviced. As a
 * server action (`trackOrgPagesNavClicked`) that put it in the App Router's
 * action queue alongside the navigation, and a queued action resolves
 * against the pre-navigation router state — `serverActionReducer` resolves
 * to `state.canonicalUrl`, the address the user just left. That is the
 * never-commits half of #13434's reproduction.
 *
 * See `src/lib/shell-transport.ts` for the mechanism and the rule this obeys.
 */

import { SHELL_ENDPOINTS, shellWrite } from '@/lib/shell-transport'

/**
 * Fire-and-forget, matching the action's own contract: `shellWrite` already
 * swallows transport failures, and an adoption event must never affect the
 * navigation the user actually asked for.
 */
export function trackOrgNavClicked(): void {
  void shellWrite(SHELL_ENDPOINTS.orgPagesNavClicked, {})
}
